import { useState } from "react";
import Navigation from "../NavigationComponent/Navigation";
import TopNavigation from "../NavigationComponent/TopNavigation";
import MessagePopup from "../PopupComponent/MessagePopup";
import GenerateCSR from "../GenerateCSRComponent/GenerateCSR";
import StoreMosipCrt from "../UploadCertificateComponent/StoreMosipCrt";
import { ReactComponent as AddIcon } from '../../Assets/img/Add-primary-icon.svg';
import { ReactComponent as UploadIcon } from '../../Assets/img/Upload-primary-icon.svg';

function Certificate() {
    const [state, setState] = useState({
        model: null,
        success: false,
        message: ""
    });

    const modelOpenHandler = (model) => {
        setState((currentState) => ({
            ...currentState,
            model: model
        }));
    }

    const modelCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            model: null
        }));
    }

    const messageDisplayHandler = (message) => {
        setState((currentState) => ({
            ...currentState,
            success: true,
            message: message
        }));
    }

    const messagePopupCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            success: false,
            message: null
        }));
    }

    return (
        <>
            <Navigation />
            <TopNavigation onPageReset={() => { }} />
            <div className="page-container">
                {state.success && <MessagePopup onClose={messagePopupCloseHandler} title="Success" body={state.message} />}
                {state.model == "gencsr-device" && <GenerateCSR keyType="Device" onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} />}
                {state.model == "upload-device" && <StoreMosipCrt keyType="Device" onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} />}
                {state.model == "gencsr-ftm" && <GenerateCSR keyType="Ftm" onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} />}
                {state.model == "upload-ftm" && <StoreMosipCrt keyType="Ftm" onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} />}
                <div className="pagetop-container">
                    <div className="pagetop-buttons-container" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <button type="button" className="secondary-button" onClick={() => modelOpenHandler("gencsr-device")}>
                            <span className="secondary-button-icon"><AddIcon /></span>
                            <span className="secondary-button-text">Generate Device CSR</span>
                        </button>
                        <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => modelOpenHandler("upload-device")}>
                            <span className="secondary-button-icon"><UploadIcon /></span>
                            <span className="secondary-button-text">Upload Device Certificate</span>
                        </button>
                        <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => modelOpenHandler("gencsr-ftm")}>
                            <span className="secondary-button-icon"><AddIcon /></span>
                            <span className="secondary-button-text">Generate FTM CSR</span>
                        </button>
                        <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => modelOpenHandler("upload-ftm")}>
                            <span className="secondary-button-icon"><UploadIcon /></span>
                            <span className="secondary-button-text">Upload FTM Certificate</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Certificate;
